import {
  DealRoomSearchResults,
  DEAL_ROOM_SEARCH,
  RwcDealRoomSearchResults,
  RWC_SEARCH_SECTION,
  SHARED_SECTION,
} from 'models/Search';

export const EMPTY_STATE: DealRoomSearchResults = {
  [DEAL_ROOM_SEARCH.DRAFTS]: [],
  [DEAL_ROOM_SEARCH.SELLING]: [],
  [DEAL_ROOM_SEARCH.BUYING]: [],
  [SHARED_SECTION.MARKETPLACE]: [],
};

export const EMPTY_RWC_STATE: RwcDealRoomSearchResults = {
  [RWC_SEARCH_SECTION.YOUR_RWC]: [],
  [RWC_SEARCH_SECTION.OTHER_RWC]: [],
  [SHARED_SECTION.MARKETPLACE]: [],
};
